import React from "react";
import { Modal } from "react-bootstrap";
import dateFormat from "dateformat";
const NFTHistoryDetails = ({ setShow, singleData, show }) => {
  const handleClose = () => {
    setShow(false);
  };

  function ModalComponent(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="announcement-modal-show notices-modal-show "
        backdrop="static"
      >
        <div className="announcement-header">
          <h4>Details</h4>
          <button onClick={handleClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <Modal.Body>
          <div className="history-details-modal-area">
            <div className="container">
              <div className="history-details-modal-item">
                <p>Name</p>
                <span>{singleData?.coin_id?.name}</span>
              </div>
              <div className="history-details-modal-item">
                <p>Symbol</p>
                <span>{singleData?.coin_id?.symbol}</span>
              </div>
              <div className="history-details-modal-item">
                <p>NFT</p>
                <span>{singleData?.coin_amount}</span>
              </div>
              <div className="history-details-modal-item">
                <p>Buy/Sell</p>
                <span>{singleData?.type}</span>
              </div>
              <div className="history-details-modal-item">
                <p>Date</p>
                <span>
                  {dateFormat(singleData?.createdAt, "mmm,")}&nbsp;
                  {dateFormat(singleData?.createdAt, "dS")}&nbsp;
                  {dateFormat(singleData?.createdAt, "yyyy")}
                </span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  return (
    <>
      <ModalComponent show={show} onHide={() => setShow(false)} />
    </>
  );
};

export default NFTHistoryDetails;
